import React, { Component } from 'react';
import Prize from './Prize.js'; //component that contains all information for each prize
import ShoppingCart from './ShoppingCart.js'; //component that contains the shopping cart
import Modal from 'react-modal';
import shoppingCart from '../asset/img/shoppingCart.png'; //shopping cart image for shopping cart button
import SelectBox from '../component/Select.js';
import axios from 'axios';
import {path, storeImagePath} from './routes.js';
import loader from '../asset/img/loader.gif';
import PropTypes from 'prop-types';

Modal.setAppElement('#root');

export default class PrizeShop extends Component{
	constructor(props){
		super(props);
		this.state = {info:[],modalIsOpen:false,enoughPoints:true,tier:'all',tiers:[],success:false,loading:false,modalPrompt:''};
		this.addToCart = this.addToCart.bind(this);
		// this.cartTotal = this.cartTotal.bind(this);
		this.removeItem = this.removeItem.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.quantityChange = this.quantityChange.bind(this);
		this.handleSelection = this.handleSelection.bind(this);
		this.submitOrder = this.submitOrder.bind(this);
	}

	handleSelection(identity,value){ //standard method for handing user input
		const theState = this.state;
		theState[identity] = value;
		this.setState(theState);
	}

	addToCart(item){ //method for adding an item to the shopping cart
		let theCart = [];
		let exists = false;
		for(let i=0;i<this.props.cart.length;i++){
			theCart[i] = this.props.cart[i];
			if(item.prize === this.props.cart[i].prize && item.size === this.props.cart[i].size && item.color === this.props.cart[i].color){ //if line item already exists within the cart, update the quantity instead of adding a duplicate line
				exists = true;
				theCart[i].quantity = Number(item.quantity) + Number(this.props.cart[i].quantity);
				theCart[i].total = Number(item.total) + Number(this.props.cart[i].total);
				

				// this.setState({cart:theCart},function(){
				// 	this.cartTotal(item,"add");
				// 	this.updateCart(this.state.cart);
				// });
			}
		}
		if(!exists){ //add item to cart if it doesnt already exist
			theCart.push(item);

		}

		this.props.updateCart(theCart,this.props.updateCartTotal(item,'add')); //update shopping cart with item to be added

		// if(!exists){
		// 	this.setState(oldState => ({cart:[...oldState.cart,item]}), function(){
		// 		this.cartTotal(item,"add");
		// 		this.updateCart(this.state.cart);
		// 	});
		// }
	}

	// cartTotal(item,action){
	// 	let total = this.state.total;
	// 	if(action === "add"){
	// 		total = Number(item.total) + Number(total);
	// 	}else if(action ==="remove"){
	// 		total = Number(total) - Number(item.total);
	// 	}
	// 	this.setState({total:total});
	// }

	removeItem(index){ //method for removing item from cart
		let items = this.props.cart;
		// items.splice(index,1);

		this.props.updateCart(items,this.props.updateCartTotal(items[index],"remove"));
		// this.setState({cart:items},function(){
		// 	this.updateCart(items);
		// });
	}

	quantityChange(id,newQuant){ //method for handling a change in the quantity of a line item in the shopping cart
		if(Number(newQuant) > 0){
			// const items = this.props.cart;
			// let unitPrice = Number((items[id].total)/(items[id].quantity));
			// items[id].quantity = Number(newQuant);
			// items[id].total = Number(newQuant*unitPrice);
			// let newTotal = 0;
			// items.forEach((item)=>{
			// 	newTotal = Number(item.total) + Number(newTotal);
			// });

			const items = this.props.cart;
			let newTotal = 0;
			let newCart = [];
			items.forEach((item,i)=>{ //calculate the new total for each lineitem and the order as a whole when the quantity of a line item is changed
				let itemTotal = Number(item.total);
				let itemQuant = Number(item.quantity);
				if(id == i){
					itemTotal = (Number(newQuant) * Number((item.total)/(item.quantity)));
					itemQuant = newQuant;
				}
				newCart.push(item);
				newCart[i].quantity = Number(itemQuant);
				newCart[i].total = Number(itemTotal);
				newTotal = Number(itemTotal) + Number(newTotal);
			});
			//this.props.updateCart(newCart,this.props.updateCartTotal(newCart[id],'add')); //update cart information
			this.props.updateCart(newCart,this.props.handleInput('cartTotal',newTotal));

			// this.setState({cart:items,total:newTotal},function(){
			// 	this.updateCart(items);
			// });
		}else{ //remove item from cart if quantity is set to 0
			this.removeItem(id);
		}
	}



	componentDidMount(){ //when component mounts, retrieve all prize and prize variant information, as well as tier information from DB
		let prizes = [];
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'prizes',kind:this.props.app,action:this.props.userInfo.userType}
		}).then((response)=>{

			if(response.data.data.length > 0){ //make sure there is actual prize info before continuing
				let j = 0;
				let prizeInfo = response.data.data;

				prizes.push({prizeID:prizeInfo[0].prizeID,prize:prizeInfo[0].prize,tier:prizeInfo[0].tier,price:prizeInfo[0].price,picture:storeImagePath+prizeInfo[0].picture,description:prizeInfo[0].description,variants:[{variantID:prizeInfo[0].variantID,size:prizeInfo[0].size,color:prizeInfo[0].color,photo:prizeInfo[0].photo}]});
				for(let i = 1; i<prizeInfo.length;i++){ //consolidate prizes and their respective variants 
					if(prizeInfo[i].prizeID === prizes[j].prizeID){
						prizes[j].variants.push({variantID:prizeInfo[i].variantID,size:prizeInfo[i].size,color:prizeInfo[i].color,photo:prizeInfo[i].photo});
					}else{
						prizes.push({prizeID:prizeInfo[i].prizeID,prize:prizeInfo[i].prize,tier:prizeInfo[i].tier,price:prizeInfo[i].price,picture:storeImagePath+prizeInfo[i].picture,description:prizeInfo[i].description,variants:[{variantID:prizeInfo[i].variantID,size:prizeInfo[i].size,color:prizeInfo[i].color,photo:prizeInfo[i].photo}]});
						j++;
					}
				}
				this.setState({info:prizes});
			}
		});

		let year = (new Date()).getFullYear(); //get current year
		axios({ //retrieve tier information for the current year
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'tiers',kind:this.props.app,year:year,action:'shop'}
		}).then((response)=>{
			let data = response.data.data;
			let theTiers = data.map((tiers)=>{
				return tiers.tier;
			});
			this.setState({tiers:theTiers});
		});

		// let sessiontotal = 0;
		// this.props.cart.forEach((item)=>{
		// 	sessiontotal += Number(item.total);
		// });
		// this.setState({cart:this.props.cart,total:sessiontotal});
	}
	openModal() { //open the modal
    	this.setState({modalIsOpen: true});
  }
	closeModal() { //close the modal
	    this.setState({modalIsOpen: false,success:false});
	}
	submitOrder(){ //method for submitting order of items currently in shopping cart
		let order = this.props.cart;
		let info = this.state.info;
		let total = this.props.cartTotal;
		let userID = this.props.userInfo.userID;
		let lineitems = [];
		if(!(total > this.props.userInfo.redeemable)){ //if the user has enough points, continue with order
			this.setState({loading:true});
			axios({ //create an entry in the orders table that contains userID, total points, and date ordered
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'orders',misc:'create',firstID:userID,quantity:total,date:'required'}
			}).then((response)=>{
				let data = response.data.data;
				let capMet = [];
					if(data.ID !== 0){ //if an entry was created in the orders table, data.ID will be the orderID
						order.forEach((orderItem)=>{
							let prizeID;
							let variantID;
							if(orderItem.size === "" || orderItem.size === "N/A"){ //prepare data 
								orderItem.size = null;
							}
							if(orderItem.color === "N/A"){
								orderItem.color = null;
							}
							for(let i = 0;i<info.length;i++){
								if(orderItem.prize === info[i].prize){
									prizeID = info[i].prizeID;
									info[i].variants.forEach((vari)=>{ //get the right variantID for each prize variant that is being ordered
										if((orderItem.size === vari.size)){ //begin
											if(orderItem.color !== null){
												console.log(orderItem.color.replace(" ", "_"), vari.color);
												if(orderItem.color.replace(/ /g,"_") === vari.color || orderItem.color === vari.color){
														variantID = vari.variantID;
												}
											}else{
												if(orderItem.color === vari.color){
													variantID = vari.variantID;
												}
											}
										}//end
									});							
								}
							}
							lineitems.push(
								axios({
									method:'post',
									url:path,
									headers:{'Content-Type':'application/json'},
									data:{endpoint:'create',table:'items',firstID:data.ID,secondID:prizeID,thirdID:variantID,quantity:orderItem.quantity}
								})
							);
						});
						let prompt = '';
						let ordertotal = this.props.cartTotal;
						axios.all(lineitems).then((response)=>{ //create line items in line items table
							response.forEach((res)=>{
								console.log(res);
								if(res.data.data.Message !== 'success'){
									capMet.push(res.data.data.Message);
								}
							});
							if(capMet.length < 1){
								this.props.redeemable("subtract",ordertotal); //update redeemable points for user
								prompt = 'Your Order has been placed!';
							}else{ //if the user has surpassed the cap on how many of a certain item can be ordered (i.e. only one $75 gift card per year), alert the user
								prompt += 'Your Order has been placed! however, ';
								capMet.forEach((prize)=>{
									for(let j = 0;j<order.length;j++){
										if(order[j].prize === prize){
											prompt += 'the item '+prize+' was removed because you have exceeded the limit that can be ordered in a year. ';
											ordertotal = Number(ordertotal) - (order[j].total);
										}
									}
								});
								this.props.redeemable("subtract",ordertotal); //update redeemable points for user
							}
							// this.setState({cart:[],total:0,loading:false,success:true,modalPrompt:prompt},function(){
							// 	this.updateCart(this.props.cart);
							// 	
							// });
							this.setState({loading:false, success:true,modalPrompt:prompt});
							this.props.updateCart([],()=>{
								this.props.updateCartTotal();
								this.props.logChange();
							});
							
						}).catch(err => console.log(err));
					}
			});
		}//deleted else
	}

	render(){
		const selectStyle = "w-80-ns w-100 ml2 h2 shadow-3 pa1 br2 b--gray bw1";
		let content;
		let tierOptions = ["all",...this.state.tiers];
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    maxWidth:'1080px',
		    transform: 'translate(-50%, -50%)',
		    borderWidth:'1px',
		    borderColor:'gray',
		    boxShadow:'0.5px 0.5px 1px 0.5px',
		    paddingTop:'0'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)',
			}
		};
		let wallet;
		console.log(this.props.userInfo);
		if(this.props.app === "lov"){ //display the user's redeemable points as their "Wallet"
			wallet = <p style={{marginLeft:'1%'}} className="b gray">Wallet: {this.props.userInfo.redeemable} points</p>;
		}else{
			wallet = <p style={{marginLeft:'1%'}}></p>;
		}
		let itemTotal = this.props.cart.length;
		const cartButton = {backgroundImage: 'url(' + shoppingCart + ')',
												backgroundSize: '60px 40px',
												 backgroundRepeat: 'no-repeat',
												 backgroundPosition: 'center',
												minWidth:'65px', minHeight:'45px',
												};
		let information = this.state.info;
		const prizes = information.map((information,i) => { //display prizes, which can be filtered by tier or all be displayed at once
			if(information.tier == this.state.tier || this.state.tier === "all"){
				return(
					<div className="fl w-33-ns w-50-m w-100 pa1 prizeDiv" key={i}>
						<Prize prize={information.prize} path={information.picture} price={information.price} variants={information.variants} onChoice={this.addToCart} child={i}/>
					</div>
				)
			}
		});
		if(this.props.active){
			let modalContent;
			if(this.state.loading){ //display loading gif
				modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
			}else if(this.state.success){ //display message
				modalContent = <div>
									<div className="fl w-100 tr mt0">
						        		<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
						        	</div>
									<p className="f3 tc">{this.state.modalPrompt}</p>
								</div>;
			}else{ //display shopping cart
				modalContent = <div>
									<div className="fl w-100 tr mt0">
						        		<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
						        	</div>
									<ShoppingCart items={this.props.cart} total={this.props.cartTotal} remove={this.removeItem} quantChange={this.quantityChange} order={this.submitOrder} limit={this.props.userInfo.redeemable} app={this.props.app}/>
								</div>;
			}
			content = <div><div className="fl w-100 b--light-silver bb" style={{maxWidth:'100%'}}>
									<div className="fl w-40-ns w-30-m w-100 tl mb1">
										{wallet}
									</div>
									<div className="fl w-20-ns w-40-m w-50 tc mt2">
										<div className="fl w-30 tr-ns tl mt2">
											<label className="b gray">Tier: </label>
										</div>
										<div className="fl w-70 tl">
											<SelectBox name="tier" identity="tier" onSelect={this.handleSelection} options={tierOptions} styles={selectStyle} val={this.state.tier}/>
										</div>
									</div>
									<div className="fl w-40-ns w-30-m w-50 tr mb1">
										<button className="br3 bw1 b red bg-white bn shadow-1" onClick={this.openModal} style={cartButton}><span style={{display:'inline-block',marginRight:'11px', marginBottom:'11px'}}>{itemTotal}</span></button>
									</div>
								</div>
									<div className="fl w-100 overflow-y-auto pt2" style={{maxHeight:'500px'}}>
										{prizes}
									</div>
								<div>
								<Modal
						          isOpen={this.state.modalIsOpen}
						          style={customStyles}
						          contentLabel="shopping cart Modal"
						          shouldCloseOnOverlayClick={false}
						          shouldCloseOnEsc={false}
						        >
						        {modalContent}
						        </Modal>
								</div></div>;
		}
		return(
			<div>
				{content}
			</div>
		);
	}
}

PrizeShop.propTypes = {
	updateCart: PropTypes.func.isRequired,
	cart: PropTypes.array.isRequired,
	cartTotal: PropTypes.number.isRequired,
	updateCartTotal: PropTypes.func.isRequired,
	userInfo: PropTypes.object.isRequired,
	redeemable: PropTypes.func.isRequired,
	app: PropTypes.string.isRequired,
	active: PropTypes.bool.isRequired,
	logChange: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/container/PrizeShop.js